<li>
  <img [src]="content?.image?.url" alt="" />
  <div class="content">
    <h4>{{ content?.titleText }}</h4>
    <p>{{ content?.text }}</p>
  </div>
</li>
